import i18n from "../../i18n";
import axios from "axios";

const actions = {
  createManagedInstructionAssignment(context, value) {
    return axios
      .post("managedInstructionAssignment", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.managedInstructionAdded"),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  removeEmployeeFromAssignment(context, val) {
    return axios
      .put(`managedInstructionAssignment/${val._id}/employee/remove`, {
        employee: val.assignments.employee,
        _id: val._id,
      })
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.assignmentDeleted"),
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  deleteManagedInstructionAssignment(context, val) {
    return axios
      .delete("managedInstructionAssignment/" + val._id)
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.managedInstructionDeleted"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateManagedInstructionAssignment(context, value) {
    return axios
      .put("managedInstructionAssignment/" + value._id, value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.managedInstructionChanged"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleManagedInstructionAssignment(context, value) {
    return axios
      .get("managedInstructionAssignment/" + value)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleManagedInstructionAssignmentPublic(context, item) {
    return axios
      .get(
        "managedInstructionAssignment/employee/" +
          item.managedInstructionAssignmentId +
          "/" +
          item.assignmentId +
          "/" +
          item.employeeId,
      )
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getAssignmentOverview(context, id) {
    return axios.get(`/managedInstructionAssignment/${id}/overview`);
  },

  async sendSingleManagedInstructionReminder(_, { _id, instructionId }) {
    const { data } = await axios.post(
      `managedInstructionAssignment/${instructionId}/${_id}/reminder`,
    );
    return data;
  },

  async sendAllManagedInstructionReminder(_, { instructionId }) {
    const { data } = await axios.post(
      `managedInstructionAssignment/${instructionId}/reminder`,
    );
    return data;
  },
};

export default actions;
